<div class="card shadow-sm mb-5 mb-xl-10">
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bold fs-3 mb-1">{{ 'HEATMAP.TITLE' | translate }}</span>
        <span class="text-muted fw-semibold fs-7">{{ 'HEATMAP.SUBTITLE' | translate }}</span>
      </h3>
    </div>
  
    <div class="card-body pt-3">
      <div class="mb-4" *ngIf="initialOrgLoadComplete">
        <button
          class="btn btn-sm btn-outline-secondary d-flex align-items-center justify-content-between w-100 mb-2"
          type="button"
          [disabled]="allOrganizations.length === 0"
          (click)="isCollapsed = !isCollapsed">
          <span>{{ 'HEATMAP.FILTER.ORG' | translate }} {{ allOrganizations.length === 0 ? '(' + ( 'HEATMAP.FILTER.NONE' | translate ) + ')' : '' }}</span>
          <i class="bi" [ngClass]="isCollapsed ? 'bi-chevron-down' : 'bi-chevron-up'"></i>
        </button>
  
        <div [class.collapse]="true" [class.show]="!isCollapsed" id="orgFilterCollapseHeatmap">
          <div class="p-3 rounded bg-body-tertiary shadow-sm">
            <div class="d-flex justify-content-start gap-3 mb-3 border-bottom pb-2">
              <button type="button" class="btn btn-link btn-sm text-decoration-none p-0"
                (click)="selectAllOrgs()" [disabled]="isLoading || allOrganizations.length === 0">
                <i class="bi bi-check-square-fill me-1"></i> {{ 'HEATMAP.FILTER.SELECT_ALL' | translate }}
              </button>
              <button type="button" class="btn btn-link btn-sm text-decoration-none p-0"
                (click)="deselectAllOrgs()" [disabled]="isLoading || allOrganizations.length === 0">
                <i class="bi bi-square me-1"></i> {{ 'HEATMAP.FILTER.DESELECT_ALL' | translate }}
              </button>
            </div>
            <div class="row g-2">
              <div *ngIf="allOrganizations.length === 0" class="col-12 text-muted small">
                {{ 'HEATMAP.FILTER.NO_ORGS' | translate }}
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngFor="let org of allOrganizations">
                <div class="form-check form-check-sm d-flex align-items-center gap-2">
                  <input class="form-check-input" type="checkbox"
                    [id]="'heatmap-org-' + org"
                    [(ngModel)]="selectedOrganizations[org]"
                    (ngModelChange)="onOrganizationSelectionChange()"
                    [disabled]="isLoading" />
                  <label class="legend-label text-truncate mb-0" [for]="'heatmap-org-' + org">
                    <span class="clickable-org-wrapper"
                      [title]="translate.instant('HEATMAP.FILTER.SHOW_DETAILS', { org: org })"
                      (click)="handleFilterLabelClick(org)">
                      {{ org }}
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div class="mb-4 text-muted" *ngIf="!initialOrgLoadComplete && isLoading">
        <i class="bi bi-hourglass-split me-1"></i> {{ 'HEATMAP.FILTER.LOADING' | translate }}
      </div>
  
      <!-- Pierwszy Heatmap -->
      <h4 class="mb-3">{{ 'HEATMAP.CHART.BILLED_MINUTES' | translate }}</h4>
      <div class="my-4">
        <div *ngIf="isLoading && initialOrgLoadComplete" class="d-flex align-items-center justify-content-center gap-2 text-muted p-5">
          <div class="spinner-border spinner-border-sm" role="status"></div>
          <span>{{ 'HEATMAP.LOADING' | translate }}</span>
        </div>
        <div *ngIf="errorMessage && !isLoading" class="alert alert-error text-muted text-center">
          <i class="bi bi-exclamation-triangle-fill me-2"></i> {{ 'HEATMAP.ERROR' | translate }}: {{ errorMessage }}
        </div>
        <div *ngIf="!isLoading && !errorMessage && initialOrgLoadComplete && heatmapOptions?.series?.length === 0 && (lastRawData && lastRawData.length > 0)" class="alert alert-warning text-muted text-center">
          <i class="bi bi-funnel-fill me-2"></i> {{ 'HEATMAP.NO_DATA_FILTERED' | translate }}
        </div>
        <div *ngIf="!isLoading && !errorMessage && initialOrgLoadComplete && (lastRawData && lastRawData.length === 0)" class="alert alert-info text-muted text-center">
          <i class="bi bi-info-circle-fill me-2"></i> {{ 'HEATMAP.NO_DATA_YEAR' | translate }}
        </div>
      </div>
  
      <div *ngIf="!isLoading && !errorMessage && initialOrgLoadComplete && heatmapOptions?.series?.length">
        <apx-chart
          #heatmapChart
          [series]="heatmapOptions.series!"
          [chart]="heatmapOptions.chart!"
          [xaxis]="heatmapOptions.xaxis!"
          [yaxis]="heatmapOptions.yaxis!"
          [plotOptions]="heatmapOptions.plotOptions!"
          [dataLabels]="heatmapOptions.dataLabels!"
          [stroke]="heatmapOptions.stroke!"
          [tooltip]="heatmapOptions.tooltip!"
          [title]="heatmapOptions.title!"
          [legend]="heatmapOptions.legend!"
          [responsive]="heatmapOptions.responsive!">
        </apx-chart>
      </div>
  
      <div *ngIf="heatmapOptions?.series?.length === 0 && (lastRawData && lastRawData.length > 0)" class="text-center text-muted p-5">
        ({{ 'HEATMAP.NO_RENDERABLE_DATA' | translate }})
      </div>
  
      <!-- Drugi Heatmap -->
      <h4 class="mt-5 mb-3">{{ 'HEATMAP.CHART.ACTUAL_MINUTES' | translate }}</h4>
      <div class="my-4">
        <div *ngIf="isLoading && initialOrgLoadComplete" class="d-flex align-items-center justify-content-center gap-2 text-muted p-5">
          <div class="spinner-border spinner-border-sm" role="status"></div>
          <span>{{ 'HEATMAP.LOADING' | translate }}</span>
        </div>
        <div *ngIf="errorMessage && !isLoading" class="alert alert-error text-muted text-center">
          <i class="bi bi-exclamation-triangle-fill me-2"></i> {{ 'HEATMAP.ERROR' | translate }}: {{ errorMessage }}
        </div>
        <div *ngIf="!isLoading && !errorMessage && initialOrgLoadComplete && heatmapOptionsDuration?.series?.length === 0 && (lastRawData && lastRawData.length > 0)" class="alert alert-warning text-muted text-center">
          <i class="bi bi-funnel-fill me-2"></i> {{ 'HEATMAP.NO_DATA_FILTERED' | translate }}
        </div>
        <div *ngIf="!isLoading && !errorMessage && initialOrgLoadComplete && (lastRawData && lastRawData.length === 0)" class="alert alert-info text-muted text-center">
          <i class="bi bi-info-circle-fill me-2"></i> {{ 'HEATMAP.NO_DATA_YEAR' | translate }}
        </div>
      </div>
  
      <div *ngIf="!isLoading && !errorMessage && initialOrgLoadComplete && heatmapOptionsDuration?.series?.length">
        <apx-chart
          #heatmapChartDuration
          [series]="heatmapOptionsDuration.series!"
          [chart]="heatmapOptionsDuration.chart!"
          [xaxis]="heatmapOptionsDuration.xaxis!"
          [yaxis]="heatmapOptionsDuration.yaxis!"
          [plotOptions]="heatmapOptionsDuration.plotOptions!"
          [dataLabels]="heatmapOptionsDuration.dataLabels!"
          [stroke]="heatmapOptionsDuration.stroke!"
          [tooltip]="heatmapOptionsDuration.tooltip!"
          [title]="heatmapOptionsDuration.title!"
          [legend]="heatmapOptionsDuration.legend!"
          [responsive]="heatmapOptionsDuration.responsive!">
        </apx-chart>
      </div>
  
      <div *ngIf="heatmapOptionsDuration?.series?.length === 0 && (lastRawData && lastRawData.length > 0)" class="text-center text-muted p-5">
        ({{ 'HEATMAP.NO_RENDERABLE_DATA' | translate }})
      </div>
    </div>
  </div>
  